import type { VNode } from '@stencil/core';
import { CustomAPI } from '@sydle/ui-api';
import { renderComponent } from '@sydle/ui-utils';
import { CustomComponentType } from '../models/models';
import { isLoggedIn } from './auth/authClient';

export const ECOMMERCE_API = new CustomAPI('604a4f573143765c4b12e1e3');
export const LOGGED_AREA_API = new CustomAPI('608181849b901904c4871557');
export const PLAN_API = new CustomAPI('6719578235cf3d071e84c379');

export async function getContentHTML(
  component: CustomComponentType,
  onlyComponent = false,
): Promise<VNode | any | undefined> {
  const COMPONENT_CONFIG_API = new CustomAPI('660b088a806eb86c5521de96');
  return await COMPONENT_CONFIG_API.fetch('getContent', component, {
    forcePost: true,
    requestParams: { addUserTokenOnHeader: true },
  })
    .then((response) => response.data)
    .then((data: any) => {
      if (onlyComponent) {
        return data.component;
      }

      if (data?.component) {
        return renderComponent(data?.component);
      }
    })
    .catch((err) => {
      throw err;
    });
}

export async function saveError(error: any) {
  if (error && ((error.message && error.message.includes('saveError')) || error.status === 401 || error.status === 0)) {
    return;
  }

  if (isLoggedIn()) {
    LOGGED_AREA_API.fetch(
      'saveError',
      { error, userAgent: window.navigator.userAgent },
      { requestParams: { addUserTokenOnHeader: true }, forcePost: true },
    );
  } else {
    ECOMMERCE_API.fetch(
      'saveError',
      { error, userAgent: window.navigator.userAgent },
      { requestParams: { public: true }, forcePost: true },
    );
  }
}
